import axiosAPI from "./basehttpinterceptor";

export const postAPI = async (url, params) => {
  let responsedata = null;
  await axiosAPI
    .post(url, params)
    .then((res) => {
      if (res != null) responsedata = res;
    })
    .catch((err) => {
      console.log("err", err);
    });
  return responsedata;
};

export const getAPI = async (url, params) => {
  let responsedata = null;
  await axiosAPI
    .get(url, params)
    .then((res) => {
      responsedata = res.data;
    })
    .catch((err) => {
      console.log("err", err);
    });
  return responsedata;
};

export const getAPIwithParams = async (url, params) => {
  let responsedata = null;
  await axiosAPI
    .get(url, { params: params })
    .then((res) => {
      responsedata = res.data;
    })
    .catch((err) => {
      console.log("err", err);
    });
  return responsedata;
};

export const putAPI = (url, params) => {
  let responsedata = null;
  axiosAPI
    .put(url, params)
    .then((res) => {
      responsedata = res.data;
    })
    .catch((err) => {
      console.log("err", err);
    });
  return responsedata;
};
export const patchAPI = async (url, params) => {
  let responsedata = null;
  await axiosAPI
    .patch(url, params)
    .then((res) => {
      responsedata = res.data;
    })
    .catch((err) => {
      console.log("err", err);
    });
  return responsedata;
};

export const deleteAPI = (url, params) => {
  let responsedata = null;
  axiosAPI
    .delete(url, params)
    .then((res) => {
      responsedata = res.data;
    })
    .catch((err) => {
      console.log("err", err);
    });
  return responsedata;
};
